import React, { Component } from "react";
import "./FinancingBanks.scss";
import CommonService from "../../../services/common-service";
import CalculatorService from "../../../services/calculator-service";

class FinancingBanks extends Component {
  banksList = [
    {
      src: "bank-icons-04.png",
      caption: "Bank Alfalah",
    },
    {
      src: "dubai-islamic.png",
      caption: "Dubai Islamic Bank",
    },
    {
      src: "bank-al-habib.png",
      caption: "Bank-Al-Aabib",
    },
    {
      src: "soneri.png",
      caption: "Soneri Bank",
    },
    {
      src: "mcb.png",
      caption: "MCB Bank",
    },
    {
      src: "askari.png",
      caption: "Askari Bank",
    },
    {
      src: "ubl.png",
      caption: "UBL Bank",
    },
    {
      src: "bop.png",
      caption: "BOP Bank",
    },
    {
      src: "js-bank.png",
      caption: "JS Bank",
    },
    {
      src: "hbl.png",
      caption: "HBL Bank",
    },
    {
      src: "faysal-bank.png",
      caption: "Faysal Bank",
    },
  ];

  constructor() {
    super();
    this.commonService = new CommonService();
    this.calculatorService = new CalculatorService();
    this.state = {
      active: null,
      percentage: 0,
      banksList: [],
    };
  }

  componentDidMount() {
    this.getFinanceOfBanks();
  }

  getFinanceOfBanks = () => {
    this.calculatorService
      .getFinance()
      .then((res) => {
        const { data } = res;
        this.setState({
          banksList: data,
        });
      })
      .catch((err) => {
        this.commonService.showToast("Something went wrong!", "error");
      });
  };

  toggle = (bank, key) => {
    if (this.props.callFrom === "carFinance") {
      return;
    }
    this.props.onSelectBank(bank);
    if (this.state.active === key) {
      this.setState({ active: null });
    } else {
      this.setState({ active: key });
    }
  };

  render() {
    const { banksList, active } = this.state;
    return (
      <div className="financing-banks-main">
        <div className="banks-row">
          {Object.keys(banksList).map((key, i) => (
            <div
              className={`bank-item ${active === key ? "active" : ""}`}
              key={i}
              onClick={() => {
                this.toggle(banksList[key], key);
              }}
            >
              <div className="banks-imgs">
                <div className="img">
                  <img loading="lazy" src={banksList[key].filter((item) => item.logo != "")[0].logo} alt={key} />
                </div>
              </div>
            </div>
          ))}
          {/* {banksList &&
              banksList.map((bank) => {
                return (
                  <div
                    className={`col-md-2 col-sm-6 col-6 bank-item ${active === bank.id ? "active" : ""}`}
                    key={bank.id}
                    onClick={() => {
                      this.toggle(bank);
                    }}
                  >
                    <div className="banks-imgs">
                      <div className="img">
                        <img loading="lazy" src={bank.logo} alt={bank.bankName} />
                      </div>
                    </div>
                  </div>
                );
              })} */}
        </div>
      </div>
    );
  }
}

export default FinancingBanks;
